import { render, staticRenderFns } from "./Seats.vue?vue&type=template&id=572f8e59&scoped=true&"
import script from "./Seats.vue?vue&type=script&lang=js&"
export * from "./Seats.vue?vue&type=script&lang=js&"
import style0 from "./Seats.vue?vue&type=style&index=0&id=572f8e59&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../var/www/html/film-screening-production/vuejs/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "572f8e59",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../var/www/html/film-screening-production/vuejs/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardText,VDivider,VFlex,VLayout})
